<template>
  <v-dialog v-model="dialog" max-width="500px">
    <v-form ref="form" @submit.prevent="() => $emit('salvar', nesh)">
      <v-card v-if="nesh" :loading="salvando">
        <v-card-title> {{ operacao === 'editar' ? 'Editar' : 'Adicionar' }} NESH </v-card-title>
        <v-card-text>
          <v-form ref="formDialog" v-model="validForm" @submit.prevent>
            <v-container>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="nesh.descricao"
                    label="Descrição"
                    required
                    :rules="[obrigatorio]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="nesh.codigo"
                    label="Codigo"
                    required
                    :rules="[obrigatorio]"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-autocomplete
                    v-model="nesh.ncm.id"
                    :items="itens.ncm"
                    :rules="[obrigatorio]"
                    label="NCM"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-alert v-if="showMessageError" dense outlined type="error">
                    {{ dataError }}
                  </v-alert>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" type="button" text @click="dialog = false">Cancelar</v-btn>
          <v-btn
            class="ml-auto"
            type="submit"
            text
            color="success"
            :disabled="!validForm"
            @click="salvar(nesh)"
            >Salvar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import NESH from '../../models/nesh'
import NESHService from '../../services/nesh/nesh'
import { obrigatorio } from '../../shareds/regrasForm'

export default {
  props: ['showDialog', 'neshParam', 'operacao', 'itens'],
  data: () => ({
    dialog: false,
    nesh: new NESH(),
    obrigatorio: obrigatorio,
    salvando: false,
    validForm: false,
    dataError: '',
    showMessageError: false
  }),
  watch: {
    showDialog() {
      this.showMessageError = false
      return this.showDialog ? (this.dialog = this.showDialog) : ''
    },
    neshParam() {
      return this.neshParam ? this.initialize() : ''
    },
    dialog() {
      return this.dialog ? true : this.fecharDialog()
    }
  },
  methods: {
    initialize() {
      this.nesh = new NESH()
      if (this.$refs.formDialog) this.$refs.formDialog.resetValidation()

      this.nesh = this.neshParam
    },

    async salvar(item) {
      this.salvando = true
      this.showMessageError = false

      try {
        const data = {
          ...item
        }

        const neshSalva =
          this.operacao === 'adicionar'
            ? await NESHService.create({ ...data })
            : await NESHService.update(data.id, data)

        this.$emit('confirmado', neshSalva)
        this.dialog = false
      } catch (error) {
        this.dataError = error.response.data.message
        this.showMessageError = true
      } finally {
        this.salvando = false
      }
    },

    fecharDialog() {
      this.$emit('update:showDialog', false)
    }
  }
}
</script>
